import useSWR from "swr";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export interface EmailHistoryItem {
  subject: string;
  body: string;
  createdAt: string;
}

export interface EmailHistoryResponse {
  data: EmailHistoryItem[];
}

export function useMeetingContactEmails(
  meetingId: number | string,
  contactId: number | string,
) {
  const service = useUserService();
  const accessToken = getUserToken();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  const url = `/api/meetings/${meetingId}/contact/${contactId}/emails`;

  const { data, error } = useSWR(url, (u) =>
    service
      .get(u)
      .set(headers)
      .then(tokenRefreshHandler)
      .then((res: Response) => res.body)
      .catch(errorHandler),
  );

  return {
    data: data as EmailHistoryResponse | undefined,
    error,
    loading: !error && !data,
  };
}

export default useMeetingContactEmails;
